import { getCookie } from "@/utils/cookies";

function getUniqueUserId() {
  const cookieName = "uniqueUserId";
  let uniqueUserId = getCookie(cookieName);

  if (!uniqueUserId) {
    uniqueUserId = [...Array(12)]
      .map(() => Math.random().toString(36)[2])
      .join("");
    document.cookie = `${cookieName}=${uniqueUserId}; path=/;`;
  }

  return uniqueUserId;
}

const fetchUserDetails = async () => {
  try {
    const res = await fetch(
      `${window.location.origin}/seeker-profile/api/rioMe`,
      {
        method: "GET",
      },
    );
    const response = await res.json();
    const email = response?.primaryEmail?.email || "";
    return email;
  } catch (error: unknown) {
    console.log("res", error);
  }
};

export const getAbModuleId = async () => {
  const isLoggedIn = !!getCookie("MSSOCLIENT");
  let userId = "";

  if (isLoggedIn) {
    userId = await fetchUserDetails();
  } else {
    const res: any = getUniqueUserId();
    userId = res;
  }
  return userId;
};

export const resolveABVariant = async (
  variantList: string[],
  payload: { experimentName: string; id: string },
  successFn: () => void,
  failFn: () => void,
) => {
  const now = new Date();
  const cachedValue = localStorage.getItem(payload?.experimentName);
  const parsedItem = cachedValue ? JSON.parse(cachedValue) : null;
  if (parsedItem?.expiry > now.getTime() && parsedItem.id === payload.id) {
    if (variantList.includes(parsedItem.value)) {
      successFn();
    } else {
      failFn();
    }
  } else {
    try {
      const response = await fetch(`/seeker-profile/api/resolveABVariant`, {
        method: "POST",
        body: JSON.stringify(payload),
      });
      const res = await response.json();
      const item = {
        value: res?.variantName,
        id: payload.id,
        expiry: now.getTime() + 86400000,
      };
      localStorage.setItem(payload?.experimentName, JSON.stringify(item));
      if (variantList.includes(res?.variantName)) {
        successFn();
      } else {
        failFn();
      }
    } catch (e) {
      failFn();
      console.log(" Getting error in abModule", e);
    }
  }
};
